import apiRequest from './apiRequest';

export default async function deleteJob(jobID: string) {
  return await apiRequest('mogen-orchestration', `/jobs/${jobID}`, {
    method: 'DELETE',
  });
}
